import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Note: we intentionally do NOT set `withCredentials: true`.
// Auth is carried by the JWT in the `Authorization: Bearer <token>` header
// (see request interceptor below). The backend also accepts the same token
// via the `access_token` cookie, but keeping the axios client in
// credentials='omit' mode avoids strict CORS validation at the browser
// level — the edge/CDN in front of the API returns
// `Access-Control-Allow-Origin: *` which, when combined with credentials,
// browsers reject and users see "Erro ao iniciar a minha sessão".
const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// CDN hostname (Bunny). Fetched once from /api/config/cdn on app load; falls
// back to a compiled-in default so images work even before the first fetch.
let CDN_HOSTNAME = process.env.REACT_APP_CDN_HOSTNAME || "unlimited-studio.b-cdn.net";
export const setCdnHostname = (host) => {
  if (host && typeof host === "string") CDN_HOSTNAME = host;
};

// Legacy paths (from Emergent Object Storage) start with "social-planner/".
// Those must still be served via the authenticated /api/files proxy until the
// admin runs the migration endpoint.
export const isLegacyPath = (path) => typeof path === "string" && path.startsWith("social-planner/");

export const fileUrl = (path) => {
  if (!path) return "";
  if (isLegacyPath(path)) {
    const token = localStorage.getItem("token");
    const qp = token ? `?auth=${encodeURIComponent(token)}` : "";
    return `${API}/files/${path}${qp}`;
  }
  // Bunny CDN — public URL, no auth token needed
  return `https://${CDN_HOSTNAME}/${path.replace(/^\/+/, "")}`;
};

export default api;
